<template>
  <div class="row">
    <div class="col-md-12">
      <span class="text-muted">
        will be posted as:
        <i class="badge badge-primary">{{ formParamScrapeSt.media_type }}</i>
      </span>

      <div class="row">
        <div class="col-md-8">
          <!-- {{assetsUrl}} -->

          <div class="col-md-12 profile-info-left">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-form-label">
                  Attach File
                  <span class="text text-danger">*</span>
                </label>
                <!-- <div class="row"> -->

                <template v-if="assetsUrl.length && files.length == 0">
                  <div class="row row-sm">
                    <div
                      class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3"
                      v-for="(imgsrc, idx) in assetsUrl"
                      :key="idx"
                    >
                      <div class="card card-file" style="width: 250px;">
                        <div class="dropdown-file" style="z-index: 1;">
                          <a href data-toggle="dropdown" class="dropdown-link">
                            <i class="fa fa-ellipsis-v"></i>
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              href="javascript:void(0)"
                              @click="removeCurrentAssets(imgsrc)"
                              class="dropdown-item"
                              >Delete</a
                            >
                          </div>
                        </div>
                        <div class="text-center">
                          <!-- <img :src="imgsrc" style="width:80%;" /> -->
                          <img
                            v-if="
                              imgsrc.includes('.jpg') ||
                                imgsrc.includes('.jpeg')
                            "
                            style="width: 100%;"
                            :src="imgsrc"
                            alt=""
                          />
                          <video
                            style="width: 100%; height: 100%; overflow: hidden;"
                            v-else-if="imgsrc.includes('.mp4')"
                            controls
                          >
                            <source :src="imgsrc" type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div
                  v-show="files.length == 0"
                  class="col-md-12 upload-drop-zone"
                  id="drop-zone"
                >
                  Drop files anywhere to upload
                </div>
                <!-- {{files}} -->
                <!-- <h4 v-if="files.length">Uploading</h4>-->
                <div class="col-md-12">
                  <ul class="upload-list" v-if="files.length">
                    <li v-for="file in files" :key="file.id" class="file-list">
                      <div class="upload-wrap">
                        <div class="file-name">
                          <!-- <i class="fa fa-photo"></i> -->
                          <img
                            style="width:30px;"
                            v-if="file.thumb"
                            :src="file.thumb"
                          />
                          {{ file.name }}
                        </div>
                        <div class="file-size">
                          {{ formatSizes(file.size) }}
                        </div>
                        <div class="file-close">
                          <span class="text-danger" v-if="file.error">{{
                            file.error
                          }}</span>
                          <span v-else-if="file.success">
                            <i class="text-success fa fa-check-circle"></i>
                          </span>
                          <span v-else-if="file.active">active</span>
                          <span v-else></span>

                          <a
                            href="#"
                            @click.prevent="
                              $refs.uploadbc.remove(file);
                              removeCurrentAssets(file.data.url);
                            "
                            class="text-warning"
                          >
                            <i class="fa fa-trash-o"></i>
                          </a>
                        </div>
                      </div>

                      <div
                        class="progress progress-xs progress-striped"
                        v-if="file.active || file.progress !== '0.00'"
                      >
                        <div
                          class="progress-bar bg-success"
                          role="progressbar"
                          :style="{ width: file.progress + '%' }"
                        ></div>
                      </div>
                      <div
                        class="upload-process"
                        v-if="file.active || file.progress !== '0.00'"
                      >
                        {{ file.progress }}% done
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="col-md-12">
                  <file-upload
                    :add-index="true"
                    class="btn btn-primary"
                    :data="objFilesMessageHandler"
                    :post-action="uploadUrl"
                    :multiple="true"
                    :headers="headers"
                    :drop="true"
                    :drop-directory="true"
                    v-model="files"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    ref="uploadbc"
                    :maximum="maximumUpload"
                    :extensions="extensions"
                  >
                    <i class="fa fa-plus"></i>
                    Select
                  </file-upload>

                  <!-- <div class="input-group-append">
                        <button
                          v-if="false"
                          @click.prevent="$refs.uploadbc.active = true"
                          class="btn btn-outline-secondary"
                          type="button"
                        >Upload File</button>
                  </div>-->
                </div>
                <div class="col-md-12 text-muted">
                  <ul
                    style=" overflow-x: scroll;overflow-y: hidden;white-space:nowrap;"
                  >
                    <li>Support files: {{ extensions }}</li>
                    <li>MaxSize: {{ formatSizes(size) }}</li>
                    <li>Maximum Upload: {{ maximumUpload }} Files</li>
                  </ul>
                </div>

                <div
                  v-if="formParamScrapeSt.media_type == 'reels'"
                  class="col-md-12"
                >
                  <div class="row">
                    <label class="col"
                      >Cover URL<span class="text text-danger">*</span></label
                    >
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="mb-3" v-if="loading">
                        <skeleton />
                      </div>

                      <div class="relative image-preview mb-3" v-if="cover_url">
                        <img
                          title="Lihat Cover"
                          class="preview"
                          :src="cover_url"
                        />

                        <button
                          @click.prevent="removeProductImage()"
                          title="Hapus Cover"
                          type="button"
                          class="remove-image"
                        >
                          &times;
                        </button>
                      </div>

                      <div class="box-image">
                        <label class="btn btn-md btn-success">
                          <input
                            type="file"
                            accept="image/jpg, image/jpeg"
                            ref="cover_url"
                            name="cover_url"
                            @change="onFileSelected()"
                          />
                          Pilih File
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <small style="color: #8e8e8e; font-weight: bold;">
                        Upload File pastikan jpg, jpeg tidak lebih dari
                        {{ formatSizes(size) }}</small
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  v-if="$refs.uploadbc && $refs.uploadbc.active == true"
                >
                  <div class="col-sm-2">
                    <Skeleton :count="1" />
                  </div>
                </div>
                <!-- </div> -->
              </div>
            </div>
            <div
              class="col-md-12"
              v-show="formParamScrapeSt.media_type == 'story' ? false : true"
            >
              <div class="form-group row">
                <label class="col-form-label">Caption</label>
                <div class="message-bar">
                  <div class="message-inner">
                    <a class="link attach-icon" @click.prevent="emojiToggle()">
                      <img style="width:30px;" src="@/assets/emoji.png" alt />
                    </a>
                    <div class="input-group m-b-30">
                      <div class="input-group-append">
                        <Emoji
                          :open="emojiAttr.open"
                          :width="emojiAttr.width"
                          :height="emojiAttr.height"
                          searchLabel="Search emoji here"
                          @click="selectedEmoji"
                        />
                      </div>
                      <textarea
                        :style="'width:100%; height:200px;'"
                        ref="messagebox"
                        v-model="caption"
                        :placeholder="'Caption...'"
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="files.length">
          <div class="col-md-12">
            <label class="badge badge-dark">Preview</label>
          </div>
          <div class="col-md-12">
            <div v-if="assetsUrl.length">
              <carousel
                :navigateTo="0"
                :autoplay="true"
                :paginationEnabled="false"
                :perPage="1"
                :navigationEnabled="true"
                :centerMode="true"
                :paginationActiveColor="'#00bddc'"
                :paginationColor="'#99e8ff'"
              >
                <slide
                  v-for="(imgSrc, idx) in assetsUrl"
                  data-index="0"
                  :key="idx"
                >
                  <!-- <img :src="imgSrc" style="width: 100%;" /> -->
                  <img
                    v-if="imgSrc.includes('.jpg') || imgSrc.includes('.jpeg')"
                    style="width: 100%;"
                    :src="imgSrc"
                    alt=""
                  />
                  <video
                    style="width: 100%; height: 100%; overflow: hidden;"
                    v-else-if="imgSrc.includes('.mp4')"
                    controls
                  >
                    <source :src="imgSrc" type="video/mp4" />
                  </video>
                </slide>
              </carousel>
            </div>
            <div v-else class="card">
              <div class="card-body">
                <img style="width:100%;" src="@/assets/placeholder.jpg" />
              </div>
            </div>
            <div
              style="margin-top:10px;"
              class="card"
              v-show="
                caption != '' && formParamScrapeSt.media_type != 'story'
                  ? true
                  : false
              "
            >
              <div class="card-body" v-html="messageFilter(caption)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

import { Skeleton } from "vue-loading-skeleton";

import { APICore } from "@/utils/servicesApi";
import {
  getXAuthAgent,
  getXAuthToken,
  getAgentSession,
  getAuthBasic
} from "@/utils/auth";

import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");

import { marketplaceIcon, formatSizes } from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUpload: FileUpload,
    Emoji: VueChatEmoji,
    Carousel,
    Slide
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        media_type: ""
      },
      assetsUrl: [],
      caption: "",
      cover_url: "",
      cover_url_temp: "",
      media_type_check: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API + this.APICore() + "/upload/file",
      maximumUpload: 10,
      maximumUploadFeeds: 10,
      maximumUploadReels: 1,
      maximumUploadStory: 1,
      accept: "image/jpeg,image/jpg,video/mp4",
      extensions: "jpg,jpeg,mp4",
      extensionsFeeds: "jpg,jpeg,mp4",
      extensionsReels: "mp4",
      extensionsStory: "jpg,jpeg,mp4",
      minSize: 1024,
      size: 1024 * 1024 * 100,
      sizeFeeds: 1024 * 1024 * 100,
      sizeReels: 1024 * 1024 * 100,
      sizeStory: 1024 * 1024 * 100,
      files: [],
      isLoading: false
    };
  },
  watch: {
    assetsUrl: {
      handler: function(val, oldVal) {
        this.formValidate();
      },
      deep: true
    },
    caption: {
      handler: function(val, oldVal) {
        this.formValidate();
      },
      deep: true
    },
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          this.caption = this.formParamScrapeSt.caption;
          this.assetsUrl = this.formParamScrapeSt.assets_url;
          this.media_type_check = this.formParamScrapeSt.media_type_check;
        }
      },
      deep: true
    },

    activeIndex: {
      handler: async function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // console.log("active index")
          // this.selectedLicense = [];
          var that = await this;
          // let oldAssets = await this.assetsUrl;

          await setTimeout(function() {
            if (val == 1) {
              switch (that.formParamScrapeSt.media_type) {
                case "feeds":
                  that.extensions = that.extensionsFeeds;
                  that.size = that.sizeFeeds;
                  that.maximumUpload = that.maximumUploadFeeds;
                  break;
                case "reels":
                  that.extensions = that.extensionsReels;
                  that.size = that.sizeReels;
                  that.maximumUpload = that.maximumUploadReels;
                  break;
                case "story":
                  that.extensions = that.extensionsStory;
                  that.size = that.sizeStory;
                  that.maximumUpload = that.maximumUploadStory;
                  break;

                default:
                  that.extensions = that.extensionsFeeds;
                  that.size = that.sizeFeeds;
                  that.maximumUpload = that.maximumUploadFeeds;
                  break;
              }

              //#endregion
              document.querySelector(".VueCarousel-wrapper").click();
              // that.assetsUrl = [];
              // this.assetsUrl = oldAssets;
            }
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            // that.formPar
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.instagramSchedule.formParamScrapeSt;
    },
    headers() {
      return {
        Authorization: this.getAuthBasic()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    removeCurrentAssets(assetUrl) {
      var index = this.assetsUrl.indexOf(assetUrl);
      if (index !== -1) {
        this.assetsUrl.splice(index, 1);
      }

      // if (this.files.length) {
      //   this.files.forEach((row, idx) => {
      //     console.log("row.data.url", row.response.data.url, idx);
      //     index = this.files.indexOf(row.response.data.url);
      //     console.log("index", index);

      //     if (index !== -1) {
      //       this.files.splice(index, 1);
      //     }
      //   });
      // }
    },
    removeProductImage() {
      this.cover_url = "";
    },
    onFileSelected() {
      this.cover_url_temp = this.$refs.cover_url.files[0];
      if (
        this.cover_url_temp.type == "image/jpg" ||
        this.cover_url_temp.type == "image/jpeg"
      ) {
        const formData = new FormData();
        formData.append("file", this.cover_url_temp);
        formData.append("folder_name", "static");
        this.loading = true;
        this.$store
          .dispatch("monitoring/upload_attachment", formData)
          .then(res => {
            const { data } = res;
            this.cover_url = data.url;
            this.$refs.cover_url.value = null;
            this.loading = false;
          })
          .catch(err => {
            this.$refs.cover_url.value = null;
            this.loading = false;
          });
      } else {
        this.$refs.cover_url.value = null;
        VueSimpleAlert.fire({
          title: "Error",
          text: "Format file tidak diperbolehkan.",
          type: "error",
          timer: 3000
        });
      }
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.caption += args.emoji;
      this.emojiToggle();
      // console.log(args); /* return {...}*/
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      // console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      // console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        // console.log("oldddd", oldFile);
        // console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            media_type: this.formParamScrapeSt.media_type,
            folder_name: "static"
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          // console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          // console.log("err", newFile.error.response);
          // console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.assetsUrl.push(newFile.response.data.url);
          // this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          // console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        var index = this.assetsUrl.indexOf(oldFile.response.data.url);
        if (index !== -1) {
          this.assetsUrl.splice(index, 1);
        }
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getAuthBasic() {
      return getAuthBasic();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    APICore() {
      return APICore();
    },
    formValidate() {
      let newParam = this.formParamScrapeSt;
      newParam.assets_url = this.assetsUrl;
      newParam.caption = this.caption;
      newParam.cover_url = this.cover_url;
      console.log("newparam", newParam);
      this.$store.dispatch("instagramSchedule/actFormParamScrapeSt", newParam);
      // console.log("newParamForm2", newParam);
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>

<style scoped>
.remove-image {
  position: absolute;
  top: 0;
  right: 15px;
  display: block;
  padding: 4px 10px;
  border-radius: 0 4px 0 4px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  border: none;
}

.image-preview img {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.image-preview img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  display: inline-block;
  padding: 0 15px;
  border-radius: 4px;
  cursor: pointer;
}

.custom-file-upload:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/instagram/instagramScheduleOfficial/components/form2.vue